import React from "react";

interface Props {
    data: any;
    show: boolean;
    onClose: () => void;
}

const ResultModal: React.FC<Props> = ({ data, show, onClose }) => {

    if (!show || !data) return null;

    const getStatus = (code: number) => {
        if (code === 200) return "OK";
        if (code >= 400) return "Error";
        return "Warning";
    };

    const getBadge = (code: number) => {
        if (code === 200) return "badge bg-success-subtle text-success";
        if (code >= 400) return "badge bg-danger-subtle text-danger";
        return "badge bg-warning-subtle text-warning";
    };

    return (
        <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.4)" }}
        >
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                <div className="modal-content">

                    {/* HEADER */}
                    <div className="modal-header">
                        <h5 className="modal-title">
                            Detalle del proceso
                        </h5>

                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                        />
                    </div>

                    {/* BODY */}
                    <div className="modal-body">

                        {/* CLIENTE */}
                        <div className="mb-4">

                            <h6 className="fw-bold mb-2">
                                Cliente
                            </h6>

                            <div className="p-3 border rounded bg-light">

                                <div>

                                    <div className="d-flex justify-content-between align-items-center">

                                        <div className="fw-semibold">
                                            {data.companyName}
                                        </div>

                                        <span className={getBadge(data.code)}>
                                            {getStatus(data.code)}
                                        </span>

                                    </div>

                                    <small className="text-muted">
                                        {data.registrationNumber}
                                    </small>

                                </div>

                            </div>

                        </div>


                        {/* DIVISIONES */}
                        {data.divisions?.map((division: any, i: number) => (

                            <div key={i} className="mb-3">

                                <div className="p-3 border rounded">

                                    <div className="d-flex justify-content-between mb-2">

                                        <div className="fw-semibold">
                                            División: {division.contractName}
                                        </div>

                                        <span className={getBadge(division.code)}>
                                            {getStatus(division.code)}
                                        </span>

                                    </div>


                                    {/* STORES */}
                                    {division.stores?.map((store: any, j: number) => (

                                        <div
                                            key={j}
                                            className="ps-3 mt-3 border-start"
                                        >

                                            <div className="d-flex justify-content-between">

                                                <div className="fw-semibold">
                                                    Comercio {store.contractName}
                                                </div>

                                                <span className={getBadge(store.code)}>
                                                    {getStatus(store.code)}
                                                </span>

                                            </div>


                                            {/* DETALLE DEL COMERCIO */}
                                            <div className="mt-2 small">

                                                <div className="text-muted">
                                                    Merchant Id: {store.merchantId}
                                                </div>

                                            </div>

                                            {store.errors?.length > 0 && (

                                                <div className="mt-2 small text-danger">
                                                    <strong>
                                                        Errores en comercio:
                                                    </strong>
                                                </div>
                                            )}



                                            {/* ERRORES DEL STORE */}
                                            {store.errors?.map((e: any, k: number) => (

                                                <div
                                                    key={k}
                                                    className="mt-2 small text-danger"
                                                >

                                                    <strong>{e.apiCode}</strong>

                                                    <div>
                                                        {e.apiMessage ?? e.apiError}
                                                    </div>

                                                </div>

                                            ))}


                                            {/* TERMINALES */}
                                            {store.devices?.map((device: any, d: number) => (

                                                <div
                                                    key={d}
                                                    className="mt-3 ps-3 border-start"
                                                >

                                                    <div className="d-flex justify-content-between">

                                                        <div>
                                                            Terminal ({device.contractName}):
                                                            <span className="text-muted">
                                                                {" "} {device.terminalId}
                                                            </span>
                                                        </div>

                                                        <span className={getBadge(device.code)}>
                                                            {getStatus(device.code)}
                                                        </span>

                                                    </div>

                                                    {device.errors?.length > 0 && (
                                                        <div className="mt-1 small text-danger">
                                                            <strong>
                                                                Errores en terminal:
                                                            </strong>
                                                        </div>
                                                    )}

                                                    {/* ERRORES DEL DEVICE */}
                                                    {device.errors?.map((e: any, k: number) => (

                                                        <div
                                                            key={k}
                                                            className="mt-1 small text-danger"
                                                        >

                                                            <strong>{e.apiCode}</strong>

                                                            <div>
                                                                {e.apiMessage ?? e.apiError}
                                                            </div>

                                                        </div>

                                                    ))}

                                                </div>

                                            ))}

                                        </div>

                                    ))}

                                </div>

                            </div>

                        ))}

                    </div>

                    {/* FOOTER */}
                    <div className="modal-footer">

                        <button
                            className="btn btn-outline-secondary"
                            onClick={onClose}
                        >
                            Cerrar
                        </button>

                    </div>

                </div>
            </div>
        </div>
    );
};

export default ResultModal;